import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addItemToList,
  addList,
} from "../../../../../store/services/Store/List";
import { setItems } from "../../../../../store/actions/Store/item";
import { showToast } from "../../../../../utils/showToast";
import moment from "moment";
import { setActiveList } from "store/actions/Store/list";
import { useNavigate } from "react-router-dom";

export const ItemRetail = () => {
  const { item } = useSelector((store) => store.listItems);
  const [quantity, setQuantity] = useState(1);
  const { user, profile } = useSelector((store) => store.userReducer);
  const { selectedStore } = useSelector((store) => store.selectedStore);
  const { activeList, lists } = useSelector((store) => store.storeLists);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let listId = activeList?.list_id;
  const createNewList = async () => {
    if (!activeList) {
      const timeStamp = moment().unix();
      const listName = timeStamp + profile.profile.first_name;
      const createList = await addList(user.accessToken, user.data.id, {
        list_name: listName,
        store_id: selectedStore.id,
      });
      listId = createList.data.id;
      dispatch(setActiveList(createList));
      return createList;
    }
  };
  const submitHander = async () => {
    try {
      await createNewList();
      const result = await addItemToList(
        user.accessToken,
        user.data.id,
        listId,
        item.EAN13,
        {
          store_id: selectedStore.id,
          quantity: parseInt(quantity) <= 0 ? parseInt(1) : parseInt(quantity),
        }
      );
      if (result.success) {
        dispatch(setItems(item));
        if (item.is_offer_available) {
          let offerNum = parseInt(item.offer_type);
          const offer = quantity > offerNum ? 0 : offerNum - quantity;
          if (quantity >= offerNum) {
            showToast(
              `Item added successfully to the list. You can also avail the  special offer.`,
              "success",
              false,
              "OK"
            );
            if (lists?.length === 0) {
              navigate(`/stores/${selectedStore.id}/dashboard`);
            }
          } else {
            showToast(
              `Item added successfully in the list. You can avail the offer by adding just ${offer.toFixed(
                1
              )} more quantity.`,
              "success",
              false,
              "OK"
            );
            if (lists?.length === 0) {
              navigate(`/stores/${selectedStore.id}/dashboard`);
            }
          }
        } else {
          showToast(result.data, "success", true, "OK");
          if (lists?.length === 0) {
            navigate(`/stores/${selectedStore.id}/dashboard`);
          }
        }
      } else {
        showToast(result.message, "error", false);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleOfferButton = async () => {
    await createNewList();
    const result = await addItemToList(
      user.accessToken,
      user.data.id,
      listId,
      item.EAN13,
      {
        store_id: selectedStore.id,
        quantity: parseInt(item.offer_type),
      }
    );
    if (result.success) {
      dispatch(setItems(item));
      showToast(result.data, "success", true, "OK");
      if (lists?.length === 0) {
        navigate(`/stores/${selectedStore.id}/dashboard`);
      }
    } else {
      showToast(result.message, "error", false);
    }
  };
  return (
    <div className="flex justify-center min-h-screen align-center">
      <div className="w-4/5 p-8 mx-auto my-auto border border-gray-100 rounded-lg shadow-lg md:w-3/5 lg:w-1/3">
        <div className="w-4/5 ml-auto mr-auto ">
          <img
            className="object-contain w-full p-1 ml-auto mr-auto border rounded-sm shadow-lg max-h-44 "
            src={item?.logo}
            alt="alt"
          />
        </div>
        <div className="mt-4 text-xl font-bold text-center text-gray-800 bg-gray-100">
          {item.name}
          {item.weight && (
            <span>
              {item.weight} {item.unit}
            </span>
          )}
        </div>

        <div>
          <div className="flex justify-between mt-1 mb-1 border-t-2 border-b-2 max-h-44">
            <h3>Brand</h3>
            <h3>{item.brandName}</h3>
          </div>
          <div className="flex justify-between mb-1 border-b-2">
            <h3>Category</h3>
            <h3>{item.categoryName}</h3>
          </div>
          <div className="flex justify-between mb-1 border-b-2">
            <h3>Weight</h3>
            <h3>
              {item.weight && (
                <span>
                  {item.weight} {item.unit}
                </span>
              )}
            </h3>
          </div>
        </div>
        <div className="my-4 text-sm">{item.name}</div>
        {item && item.is_offer_available && (
          <div className="flex flex-col items-center justify-center">
            <h1 className="text-sm font-body text-theme-color text-bold">
              SPECIAL OFFER
            </h1>
            <button
              onClick={handleOfferButton}
              className="px-4 py-2 my-1 text-sm font-bold text-white border rounded-md shadow-md bg-theme-color hover:bg-lighterPurple"
            >
              Buy {item.offer_type} {item.unit} for £ {item.offer_price}
            </button>
          </div>
        )}
        <div className="flex justify-between gap-4 mt-4">
          <button
            onClick={submitHander}
            className="w-1/2 px-4 py-2 my-1 text-sm font-bold text-white border rounded-md shadow-md bg-theme-color hover:bg-lighterPurple"
          >
            Add to Active List
          </button>
          <input
            className="w-1/2 px-2 py-2 my-1 text-sm font-bold text-center border rounded-md shadow-md "
            type="number"
            placeholder="Enter quantity"
            min="0"
            pattern="[0-9]+"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};
